export const SET_SELECTED_MEMBER_NUMBER = 'setSelectedMemberNumber'
